import whishlist from "./whishlist"
export default whishlist;
